import { useState } from "react";
import { Lists } from "../../components/common/Lists";
import TableComponent from "../../components/common/Tables";
import { useGetCoursePlansQuery } from "../../hooks/useGetCoursePlansQuery";
import { CoursePlanType } from "../../types/CoursePlan";
import { Pencil1Icon } from "@radix-ui/react-icons";
import { useNavigate } from "react-router-dom";
import { routes } from "../../routes";
import { useAppDispatch } from "../../hooks/hooks";
import { setUpdateCoursePlanData } from "../../redux/slices/school/coursePlan";

const columnNamesMap: { [key: string]: string } = {
    course: 'Curso',
    academicYear: 'Ano académico'
}

export const CoursePlans = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const { data, status } = useGetCoursePlansQuery({ PageNumber: currentPage, PageSize: 400 });


    const handlerPageChange = (page: number) => {
        setCurrentPage(page);
    }

    const handlerClickCreate = (event: any): void => {
        navigate(routes.createCoursePlan);
    }

    const handleEdit = (coursePlan: CoursePlanType) => {
        dispatch(setUpdateCoursePlanData(coursePlan));
        navigate(routes.updateCoursePlan);
    }

    const options = data?.items.map(() => [
        {
            label: 'Editar',
            onClick: (coursePlan: CoursePlanType) => handleEdit(coursePlan),
            icon: <Pencil1Icon />
        }
    ]);

    return (
        <Lists
            status={status}
            TableComponent={() =>
                <TableComponent
                    columns={Object.keys(columnNamesMap)}
                    items={data?.items || []}
                    options={options}
                    columnNamesMap={columnNamesMap}
                    totalPages={data?.totalPages || 1}
                    currentPage={currentPage}
                    onPageChange={handlerPageChange}
                />

            }
            handleClickCreate={handlerClickCreate}
        />


    );
}